// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import FormValidation from "../shared/form_validation"
import axios from 'axios'

import VModal from 'vue-js-modal';
Vue.use(VModal);

import VueSweetalert2 from 'vue-sweetalert2';

const swal_options = {
  allowOutsideClick: false,
  allowEscapeKey: false,
  allowEnterKey: false,
  confirmButtonColor: '#2178ff'
}
Vue.use(VueSweetalert2, swal_options);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

// vue-moment
import Moment from 'vue-moment'
Vue.use(Moment);

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime)

// global image cropper
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';
Vue.use(Croppa);

Vue.config.devtools = true

// For development purposes
// if (location.hostname.indexOf('hopsock.com') === -1 || location.hostname.indexOf('reset-dev.reset.com') === -1 ) {
//   Vue.config.devtools = true
// } else {
//   Vue.config.devtools = false
// }

document.addEventListener('DOMContentLoaded', () => {
  FormValidation.init();
});
